import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21be7a6a&scoped=true&"
import script from "./index.js?vue&type=script&lang=ts&"
export * from "./index.js?vue&type=script&lang=ts&"
import style0 from "./index.scss?vue&type=style&index=0&id=21be7a6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be7a6a",
  null
  
)

export default component.exports